module.exports = __webpack_public_path__ + "img/ur.1f955112.png";